// NEPOTRIVIRILE ÎNTRE ACTE, ca text pe care îl citește omul la hover.
//
// Serverul spune ce câmp, ce valoare a dat fiecare act și pe care a ales-o
// (`Conflict` din `dosarclient`). Pastila de pe ecranul de locație număra
// conflictele, iar tooltipul lipea valorile brute: pentru adresă, un obiect cu
// stradă/localitate/județ, ieșit în tooltip ca «[object Object]». Omul vedea că
// E o nepotrivire, dar nu și CARE — și o nepotrivire pe care n-o poți vedea nu
// e o informație, e o grijă.
import type { Cheie, CheiePlural } from "../i18n";
import type { Conflict } from "./dosarclient";

type T = (cheie: Cheie, valori?: Record<string, string | number>) => string;
type Tn = (cheie: CheiePlural, n: number) => string;

// Câmpurile pe care consolidarea le compară între acte (importer
// `SURSE_PERMISE`); un câmp necunoscut rămâne cu numele lui tehnic, ca să nu
// dispară din tooltip.
const ETICHETE: Record<string, Cheie> = {
  adresa: "loc.nep.camp.adresa",
  suprafata_teren_mp: "loc.nep.camp.suprafata_teren_mp",
  suprafata_acte_mp: "loc.nep.camp.suprafata_acte_mp",
  suprafata_masurata_mp: "loc.nep.camp.suprafata_masurata_mp",
  numar_cadastral: "loc.nep.camp.numar_cadastral",
  carte_funciara: "loc.nep.camp.carte_funciara",
  categoria_folosinta: "loc.nep.camp.categoria_folosinta",
  contur: "loc.nep.camp.contur",
  laturi: "loc.nep.camp.laturi",
  vecinatati: "loc.nep.camp.vecinatati",
  regim_inaltime: "loc.nep.camp.regim_inaltime",
  pot_max: "loc.nep.camp.pot_max",
  cut_max: "loc.nep.camp.cut_max",
  beneficiar: "loc.nep.camp.beneficiar",
};

/** O valoare oricum ar veni ea din act -> un șir scurt.
 *  Adresa e un obiect cu părți: se înșiră părțile care există, în ordinea din
 *  act. O listă (laturi, vecinătăți) nu se transcrie — se spune câte sunt. */
export function textValoare(v: unknown, tn: Tn): string {
  if (v == null || v === "") return "—";
  if (typeof v === "number") return String(v);
  if (typeof v === "string") return v;
  if (Array.isArray(v)) return tn("loc.nep.elemente#n", v.length);
  if (typeof v === "object") {
    const parti = Object.values(v as Record<string, unknown>)
      .filter((x) => x != null && x !== "")
      .map((x) => (typeof x === "object" ? JSON.stringify(x) : String(x)));
    return parti.length ? parti.join(", ") : "—";
  }
  return String(v);
}

/** Toate nepotrivirile, un rând fiecare:
 *  «Adresa: „X" (CU.pdf) ≠ „Y" (plan.pdf) · se folosește CU.pdf». */
export function textNepotriviri(conflicte: readonly Conflict[], t: T, tn: Tn): string {
  return conflicte.map((c) => {
    const camp = ETICHETE[c.camp] ? t(ETICHETE[c.camp]) : c.camp;
    const valori = c.valori
      .map((v) => `„${textValoare(v.valoare, tn)}” (${v.sursa})`)
      .join(" ≠ ");
    return `${camp}: ${valori} · ${t("loc.nep.folosit", { sursa: c.folosit })}`;
  }).join("\n");
}
